module.exports = __webpack_public_path__ + "static/media/iot.8fe6161f.jpg";